import { Directive, ViewContainerRef, Input, inject, OnChanges } from '@angular/core';

import { environment } from '../../environments/environment.local';

import { EditorIdService } from '../providers/editor-id.service';

@Directive({
  selector: '[appEditorId]',
  standalone: true,
})
export class EditorIdDirective implements OnChanges {

  @Input() public appEditorId?: string;

  private nativeElement = inject(ViewContainerRef).element.nativeElement;
  private editorIdService = inject(EditorIdService);

  private initialized = false;

  public ngOnChanges(): void {
    if (this.initialized === true) {
      return;
    }

    // If we are in FirstSpirit
    if (environment.firstSpirit === true && this.appEditorId) {
      this.editorIdService.addEditorId(this.nativeElement, this.appEditorId);
      this.initialized = true;
    }
  }

}
